import {createSlice} from '@reduxjs/toolkit'

const getInitialState = () => ({
  popupOpen: false
})

const percentagePopupSlice = createSlice({
  name: 'percentagePopup',
  initialState: getInitialState(),
  reducers: {
    setPopupOpen: (state, action) => {
      state.popupOpen = action.payload
    }
  }
})

// Export actions
export const {setPopupOpen} = percentagePopupSlice.actions

// Export selectors
export const selectPopupOpen = (state) => state.percentagePopup.popupOpen

// Export reducer as default
export default percentagePopupSlice.reducer
